<template>
  <Teleport to="body">
  <div class="widget-container eh-popup-overlay" @click.self="closeWidget">
    <div class="widget-panel eh-popup-panel">
    <div class="title-bar">
      <span class="title-bar-spacer" aria-hidden="true"></span>
      <div class="title"><h1>Order Lookup</h1></div>
      <button
        type="button"
        class="widget-close"
        title="Close"
        aria-label="Close"
        @click="closeWidget"
      >
        ✕
      </button>
    </div>
    <div class="widget-body">
      <div class="left-sidenav"></div>
      <div class="canvas">
        <div class="search-area">
          <div class="container">
            <div class="srchiconbutton">
              <label
                ><input
                  type="checkbox"
                  @change="resetFilterValues()"
                  name="accounttype"
                  v-model="accountype"
                />Account Type</label
              >
              <label
                ><input
                  type="checkbox"
                  @change="resetFilterValues()"
                  name="srchbyname"
                  v-model="srchbyname"
                />Search By Name</label
              >
              <label
                ><input
                  type="checkbox"
                  @change="resetFilterValues()"
                  name="ordertype"
                  v-model="ordertype"
                />Search Order Type</label
              >
              <label
                ><input
                  type="checkbox"
                  @change="resetFilterValues()"
                  name="orderstastus"
                  v-model="orderstatus"
                />Search Order Status</label
              >
              <label
                ><input
                  type="checkbox"
                  @change="resetFilterValues()"
                  name="dtrange"
                  id="dtrange"
                  v-model="srchdaterng"
                />Search DateRange</label
              >
              <a
                href="#"
                @click.prevent="clearFilter"
                id="clearfilter"
                title="clear fliter"
                >Clear Filter</a
              >
            </div>
            <div class="filtertype-canvas">
              <div
                v-if="accountype == true"
                class="Account-type-canvas col-sm-12 col-md-12 col-lg-12"
              >
                <label>Account Type</label>
                <select id="accntselect" v-model="accounttypevalue">
                  <option selected value="Select Account Type">Account Type</option>
                  <option value="Provider">Provider</option>
                  <option value="Nurse">Nurse</option>
                  <option value="Allied Professional">Allied Proffesional</option>
                </select>
              </div>
              <!--endaccnttype-->
              <div
                v-if="ordertype == true"
                class="Order-type-canvas col-sm-12 col-md-12 col-lg-12"
              >
                <label>Order Type</label>
                <select id="ordtypeselect" v-model="ordertypevalue">
                  <!-- Order type exclusively for medications or procedures,
                   can place type of order in another filter -->
                  <option selected value="Select Order Type">Order Type</option>
                  <option value="Medication">Medication</option>
                  <option value="Procedure">Procedure</option>
                </select>
              </div>
              <!--endordertype-->
              <div
                v-if="orderstatus == true"
                class="Order-type-canvas col-sm-12 col-md-12 col-lg-12"
              >
                <label>Order Status</label>
                <select id="ordtypeselect" v-model="orderstatusvalue">
                  <option selected value="Select Order Type">Order Status</option>
                  <option value="Active">Active</option>
                  <option value="Pending">Pending</option>
                  <option value="Active-Pending">Active-Pending</option>
                </select>
              </div>
              <!--endordertype-->
              <div
                v-if="srchdaterng == true"
                class="order-dtrange col-sm-12 col-md-12 col-lg-12"
              >
                <label>Start Date:</label
                ><input v-model="orderstartdt" type="date" id="ordtst-field" />
                <label>End Date:</label
                ><input v-model="orderenddate" type="date" id="ordenddt-field" />
              </div>
              <!--endorddtrnge-->
            </div>
            <!--endfiltertype-canvas-->
            <div
              v-if="srchbyname == true"
              class="srchname-canvas col-sm-12 col-md-12 col-lg-12"
            >
              <label>Search By Patient Name:</label
              ><input
                type="text"
                v-model="srchpatientname"
                name="patientname"
                placeholder="Search Patient Name"
              />
            </div>
            <!--endsrchnamecanvas-->
            <div class="srchbtn-canvas col-sm-12 col-md-12 col-lg-12">
              <input
                type="button"
                class="ordercta-btn"
                @click="FilterOrderType()"
                value="Filter Orders"
              />
            </div>
            <!--endsrchcanvas-->
          </div>
          <div class="order-grid" v-if="ordresults && orderResults == true">
            <!-- Column headers to be more descriptive and for CSS purposes -->
            <table class="order-results-table">
              <colgroup>
                <col class="col-patient" />
                <col class="col-med" />
                <col class="col-date" />
                <col class="col-time" />
                <col class="col-otype" />
                <col class="col-status" />
                <col class="col-nurse" />
                <col class="col-provider" />
                <col class="col-actions" />
              </colgroup>
              <thead>
                <tr>
                  <th>Patient</th>
                  <th>Medication/Procedure</th>
                  <th>Order Date</th>
                  <th>Order Time</th>
                  <th>Order Type</th>
                  <th>Status</th>
                  <th>Nurse Signature</th>
                  <th class="th-provider">Provider Signature</th>
                  <th class="th-actions" aria-hidden="true"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ord, index) in ordresults" :key="index">
                  <td>{{ patientDisplayName(ord) }}</td>
                  <td class="td-order-item">{{ orderItemLabel(ord) }}</td>
                  <td>{{ ord.orderDate }}</td>
                  <td>{{ formatOrderTime(ord.orderTime ?? ord.ordertime) }}</td>
                  <td>{{ ord.orderType }}</td>
                  <td>{{ ord.status }}</td>
                  <td>{{ ord.nurseSignature }}</td>
                  <td>{{ ord.providerSignature }}</td>
                  <td class="td-actions">
                    <button
                      type="button"
                      class="order-row-open-btn"
                      @click="RetrieveOrder(ord)"
                    >
                      Open
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!--for loop and spit out grid items in this container-->
          </div>
        </div>
      </div>
      <!--endcanvas-->
    </div>
    <!--endwidgetbody-->
    </div>
    <!--endwidgetpanel-->
  </div>
  <!--endwidgetcontainer-->
  </Teleport>
</template>
<!--<template>
  <div class="pendingorder-container col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <pendingorder-popup
            class="pendingorder_popup"
            ref="pndordpop"
            :orderNum="orderNum"
            :patient="ordData"
            :firstName="clientFname"
            :lastName="clientLname"
            :id="'pendingorder_popup'"
          />
      </div>
  </div>
</template> -->

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import Editor from "@tinymce/tinymce-vue";
import PendingOrderPopup from "@/components/private-layouts/PendingOrderPopup.vue";
import axios from "axios";
import { count } from "d3";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OrderWidget",
  data() {
    return {
      message: "",
      orderstartdt: "", //start date value
      orderenddate: "", // end date value
      srchdaterng: false, //search date checkbox
      dtrangevalue: "",
      srchbyname: false, //searchbyname checkbox
      srchpatientname: "", //searchbyname textbox
      ordertype: false, //order type checkbox
      ordertypevalue: "",
      accountype: false, //account type checkbox
      orderResults: true,
      accounttypevalue: "",
      orderstatus: false,
      orderstatusvalue: "",
      accntype: "",
      clientFname: "",
      clientLname: "",
      ordData: [],
      orderNum: 0,
      //dtrange:false,
      ordresults: [],
      // ordresults: [
      //     {
      //       patientid: 3,
      //       accountnumber: "904500",
      //       firstname: "Kevin",
      //       lastname: "James",
      //       ordernumber: "3",
      //       status: "Active",
      //       AdmitDate: "2024-12-05",
      //       NurseSig: "Donna Jones",
      //       ProvSig: "Keyon Whiteside"
      //     },
      //     {
      //       patientid: 4,
      //       accountnumber: "904500",
      //       firstname: "Kevin",
      //       lastname: "James",
      //       ordernumber: "4",
      //       status: "Active",
      //       AdmitDate: "2024-12-05",
      //       NurseSig: "Donna Jones",
      //       ProvSig: "Keyon Whiteside"
      //     }
      //   ]
    };
  },
  components: {
    editor: Editor,
    "pendingorder-popup": PendingOrderPopup,
  },
  props: {
    orders: {},
    type: String,
    time: String,
    accountNum: {
      type: [Number, String],
      default: () => 0,
    },
    proflicense: {
      type: String,
      default: () => "",
    },
    ownerUniqueId: {
      type: String,
      default: "",
    },
    accounttype: {
      type: String,
      default: () => "",
    },
  },
  async mounted() {
    let date = new Date();
    let today = date.toISOString().substring(0, 10);
    this.startDt = today;
    this.endDt = today;
    // console.log(this.ordresults);
  },
  computed: {
    ...mapGetters("login", {
      user: "getUser",
    }),
    ...mapGetters("login", {
      allData: "getAllData",
    }),
  },
  methods: {
    async RetrieveOrder(order) {
      this.$emit("custom-event", order);
    },
    // Combines first and last name from order object into a single string
    patientDisplayName(ord) {
      const parts = [ord?.patient_first_name, ord?.patient_last_name]
        .map((s) => (s == null ? "" : String(s).trim()))
        .filter(Boolean);
      return parts.length ? parts.join(" ") : "—";
    },
    // Combines medication or procedure name from order object into a single string
    orderItemLabel(ord) {
      const name = ord?.orderItemName ?? ord?.orderitemname;
      const trimmed = name != null ? String(name).trim() : "";
      if (trimmed) return trimmed;
      const t = ord?.procOrMed != null ? String(ord.procOrMed).trim() : "";
      return t || "—";
    },
    // Formats the order time from the order object into a more readable format
    formatOrderTime(raw) {
      if (raw == null || raw === "") return "—";
      const s = String(raw).trim();
      if (!s) return "—";
      if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(s)) return s.length > 5 ? s.slice(0, 8) : s;
      const d = new Date(s.replace(" ", "T"));
      if (!Number.isNaN(d.getTime())) {
        return d.toLocaleTimeString(undefined, {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
      }
      return s;
    },
    resetFilterValues() {
      if (this.srchdaterng == true) {
        // console.log("Date range Checked - do nothing because the axios call will grab values and send server side");
      } else {
        // console.log("Date Range Not Checked- Lets clear");
        //lets make sure to clear both date fields out so that our back-end filters can process correctly
        this.orderstartdt = "";
        this.orderenddate = "";
      }
      if (this.srchbyname == true) {
        //do nothing bckend proceessing will pick up the field value
      } else {
        this.srchpatientname = "";
      }
      if (this.ordertype == true) {
        //do nothing bckend proceessing will pick up the field value
      } else {
        this.ordertypevalue = "";
      }
      if (this.orderstatus == true) {
        //do nothing bckend proceessing will pick up the field value
      } else {
        this.orderstatusvalue = "";
      }
      // this.srchdaterng = this.$refs.dtrange.checked;
      // alert(this.srchdaterng);
    },
    clearFilter() {
      // Filters not only need to be unchecked, but also need to be cleared/set to default values
      this.srchdaterng = false;
      this.accountype = false;
      this.srchbyname = false;
      this.ordertype = false;
      this.orderstatus = false;
      this.orderstartdt = "";
      this.orderenddate = "";
      this.srchpatientname = "";
      this.ordertypevalue = "Select Order Type";
      this.orderstatusvalue = "Select Order Type";
      this.accounttypevalue = "Select Account Type";
    },
    async FilterOrderType() {
      // console.log(this.accounttypevalue);
      // console.log(this.srchpatientname);
      // console.log(this.ordertypevalue);
      // console.log(this.dtrangevalue);
      // console.log(this.orderstartdt);
      // console.log(this.orderenddate);
      // console.log(this.orderstatusvalue);
      // console.log(this.accounttype);
      // Eliminating empty string concats
      let dtRange = (this.orderstartdt + " " + this.orderenddate).trim();

      const rawOwner = this.ownerUniqueId;
      const ownerUid =
        (rawOwner && String(rawOwner).trim()) ||
        this.allData?.patient?.externId
        "";

      let content = {
        OrderFilter: {
          API_Meth: "NEW_OrderLookUp",
          ordtype: this.ordertypevalue,
          patientname: this.srchpatientname,
          srchdtrange: dtRange,
          accounttype: this.accounttypevalue,
          orderstatus: this.orderstatusvalue,
          accountnumber: this.accountNum,
          owner_unique_ID: ownerUid,
          emraccounttype: this.accounttype,
        },
      };
      console.log(content);
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          let results = res.data.records;
          if (results != "" || count(results) > 0) {
            //update the ordresult variable
            this.ordresults = results;
            // console.log(results);
          } else {
            this.ordresults = [];
          }
        });
    },
    async orderTypeFilter() {},
    closeWidget() {
      $(".widget-container").removeClass("open").css("display", "none");
    },

    // // console.log(content)
  },
};
</script>

<style scoped>
/*@import "/keyon"; */
@import url("https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Satisfy&display=swap");
.satisfy-regular {
  font-family: "Satisfy", serif;
  font-weight: 400;
  font-style: normal;
  font-size: 22px;
}
.search-area .container {
  flex-direction: column;
}
input[type="text"] {
  width: 220px;
  height: 45px;
  border: 3px;
  border-top-style: none;
  border-left-style: none;
  border-right-style: none;
  border-top-style: none;

  border-bottom-style: solid;
  border-bottom-width: 1px;
  background-color: aliceblue;
}
input[type="date"] {
  width: 220px;
  height: 45px;
  border: 3px;
  border-top-style: none;
  border-left-style: none;
  border-left-style: none;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  background-color: aliceblue;
}
#ordtypeselect {
  margin-left: 15px;
  width: 220px;
  border-top-style: none;
  border-left-style: none;
  border-right-style: none;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  background-color: aliceblue;
}
#accntselect {
  width: 220px;
  margin-left: 15px;
  margin-bottom: 10px;
  border-top-style: none;
  border-left-style: none;
  border-right-style: none;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  background-color: aliceblue;
}
input[type="checkbox"] {
  margin-right: 11px;
}
.srchiconbutton label {
  margin-right: 8px;
}
.widget-container {
  /* Backdrop color + z-index from brand-ds (.eh-popup-overlay / --eh-popup-*). */
  display: none;
  position: fixed;
  inset: 0;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.widget-container.open {
  display: flex;
}
.widget-panel {
  /* Surface, border, radius from brand-ds (.eh-popup-panel / --eh-popup-*). */
  width: min(1280px, 97vw);
  max-height: 90vh;
  height: auto;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--eh-divider, #e2e8f0);
  background: transparent;
  color: var(--eh-teal-ink, #24555b);
}
.title-bar-spacer {
  width: 28px;
  flex-shrink: 0;
}
.title-bar .title {
  flex: 1;
  text-align: center;
}
.title-bar .title h1 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--eh-teal-ink, #24555b);
}
.widget-close {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: var(--eh-teal-deep, #2f6f76);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  border-radius: 6px;
  padding: 0;
}
.widget-close:hover {
  background: var(--eh-teal-wash, #dceeef);
  color: var(--eh-teal-ink, #24555b);
}
.widget-body .container {
  display: flex;
  flex-direction: column !important;
}
.srchiconbutton {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.Account-type-canvas {
  margin-top: 10px;
  margin-bottom: 10px;
}
.Account-type-canvas label {
  margin-top: 2px;
}
.Order-type-canvas {
  margin-top: 10px;
  margin-bottom: 10px;
}
.order-dtrange {
  margin-top: 10px;
  margin-bottom: 10px;
}
.order-dtrange label {
  margin-top: 15px;
}
#ordenddt-field {
  margin-left: 22px;
  margin-top: 4px;
}
#ordtypeselect {
  margin-left: 32px;
}
.srchname-canvas {
  margin-top: 10px;
  margin-bottom: 10px;
}
.srchname-canvas label {
  margin-top: 12px;
}
.srchname-canvas input[type="text"] {
  margin-left: 12px;
}
#accntselect {
  margin-left: 21px;
}
.widget-body .container div {
  display: flex;
  justify-content: flex-start;
}
.filtertype-canvas {
  flex-direction: column;
}
.ordercta-btn {
  background-color: #698acf;
  color: #ffffff;
  font-weight: 600;
  width: 145px;
  height: 40px;
  border-radius: 4px;
}
#ordtst-field {
  margin-left: 42px;
  margin-right: 15px;
}

.order-grid {
  z-index: 1;
  position: relative;
  background-color: #aebac4;
  overflow: auto;
  max-height: min(420px, 50vh);
  border-style: solid;
  border-width: 1px;
}
.order-results-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.order-results-table th,
.order-results-table td {
  padding: 10px 8px;
  text-align: left;
  vertical-align: top;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}
.order-results-table th {
  font-weight: 600;
  font-size: 0.85rem;
}
.order-results-table .col-patient {
  width: 10%;
}
.order-results-table .col-med {
  width: 17%;
}
.order-results-table .col-date {
  width: 10%;
}
.order-results-table .col-time {
  width: 9%;
}
.order-results-table .col-otype {
  width: 10%;
}
.order-results-table .col-status {
  width: 9%;
}
.order-results-table .col-nurse {
  width: 10%;
}
.order-results-table .col-provider {
  width: 15%;
}
.order-results-table .col-actions {
  width: 10%;
}
.order-results-table .th-provider {
  white-space: nowrap;
}
.order-results-table .td-actions {
  text-align: center;
  vertical-align: middle;
  padding-left: 6px;
  padding-right: 6px;
}
.order-row-open-btn {
  background-color: #698acf;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.8rem;
  padding: 6px 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}
.order-row-open-btn:hover {
  background-color: #5a7ab8;
}
.order-row-open-btn:focus {
  outline: 2px solid #3d5a99;
  outline-offset: 2px;
}
.order-results-table .td-order-item {
  font-size: 0.92rem;
}
tbody tr:nth-child(even) {
  background-color: #98bfe1;
}
tbody tr:nth-child(odd) {
  background-color: #ffffff;
}
.order-results-table thead {
  background-color: #a7afaf;
  color: #1f1f1f;
}
.order-results-table thead th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
